/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-unstable-nested-components */
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ChevronIcon from "../../../Common/Svgs/ChevronIcon";
import CustomTable from "../../../Core/Components/CustomTable";
import { FinanceHoverIcon } from "../../../Common/Svgs/FinanceIcon";
import { getTableContainerHeight } from "../../../Utils/getTableContainerHeight";
import { getAllLocationsV3 } from "../../../Redux/APIs/locationsAPI";
import { getUserByEmail } from "../../../Redux/APIs/systemUsersAPI";
import { columns } from "./constants";
import { updateRates } from "../../../Redux/Slices/rates.slice";
import useDebounce from "../../../Core/hooks/useDebounce";
import { getAgriTechRateList } from "../../../Redux/APIs/ratesAPI";
import AgriTechHeader from "./AgriTechHeader";
import DeleteAgriTechModal from "./DeleteAgriTechModal";

const LOCAL_DEFAULT_LIMIT = 10;

const AgriTechList = () => {
  const dispatch = useDispatch();

  const { userDetails } = useSelector((state) => state.loggedInUser);

  const { agriTechRateList, deleteAgriTechModal } = useSelector(
    (state) => state.rates,
  );

  const tableContainerRef = useRef(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");

  const debounceSearch = useDebounce(search, 500);

  // fetch the agri tech rates along with the filters
  useEffect(() => {
    const filterObj = {
      limit: LOCAL_DEFAULT_LIMIT,
      offset: ((currentPage || 1) - 1) * LOCAL_DEFAULT_LIMIT,
    };

    if (debounceSearch) filterObj.searchQuery = debounceSearch;

    dispatch(getAgriTechRateList(filterObj));
  }, [dispatch, currentPage, debounceSearch]);

  // fetch user details and all the locations and all the agri tech rates (to get permissions on every refresh)
  useEffect(() => {
    dispatch(getUserByEmail({ email: userDetails.email }));
    dispatch(getAllLocationsV3());
  }, [dispatch]);

  return (
    <div>
      <div>
        <AgriTechHeader search={search} setSearch={setSearch} />

        <div
          className={`h-[calc(100vh-72px-71px-69px-40px)] ${
            agriTechRateList?.result?.length && "overflow-y-scroll"
          }`}
          ref={tableContainerRef}
        >
          <CustomTable
            disableScroll
            columns={columns}
            data={agriTechRateList.result}
            emptyState={
              <FinanceHoverIcon size={16} className="text-dark-grey-text" />
            }
            emptyStateHeight={getTableContainerHeight(tableContainerRef)}
            rowClassName="group"
            pagination={{
              pageSize: LOCAL_DEFAULT_LIMIT,
              total: agriTechRateList?.totalRecords,
              showSizeChanger: false,
              onChange: (page) => {
                setCurrentPage(page);
              },
              current: currentPage,
              itemRender: (current, type, originalElement) => {
                const lastPage = agriTechRateList.totalRecords / current;

                if (type === "prev" && current === 0) {
                  return (
                    <button
                      type="button"
                      className="-rotate-180 rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
                      style={{
                        pointerEvents: "none",
                      }}
                    >
                      <ChevronIcon className="stroke-dark-gray" />
                    </button>
                  );
                }

                if (type === "prev" && current > 0) {
                  return (
                    <button
                      type="button"
                      className="-rotate-180 rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
                    >
                      <ChevronIcon className="stroke-dark-gray" />
                    </button>
                  );
                }

                if (type === "next" && lastPage <= 10) {
                  return (
                    <button
                      type="button"
                      className="rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
                      style={{ pointerEvents: "none" }}
                    >
                      <ChevronIcon className="stroke-dark-gray" />
                    </button>
                  );
                }

                if (type === "next") {
                  return (
                    <button
                      type="button"
                      className="rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
                    >
                      <ChevronIcon className="stroke-dark-gray" />
                    </button>
                  );
                }

                return originalElement;
              },
            }}
          />
        </div>
      </div>

      <DeleteAgriTechModal
        visible={deleteAgriTechModal}
        onCancel={() =>
          dispatch(updateRates({ key: "deleteAgriTechModal", value: false }))
        }
      />
    </div>
  );
};

export default AgriTechList;
